import { useState } from "react";
import { Typography, Box, IconButton, Tooltip } from "@mui/material";
import { History } from "@mui/icons-material";
import { useTimeOffSummary } from "../utils/useTimeOffSummary";
import { HolidaysSummaryCell } from "./HolidaysSummaryCell";
import { VacationHistoryModal } from "./VacationHistoryModal";

export const TimeOffSummary = () => {
    const { monthHolidayHours, ...holidaysSummary } = useTimeOffSummary();
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);

    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography color="primary" variant="h6">
                    Férias
                </Typography>
                <Tooltip title="Histórico de férias" arrow>
                    <IconButton size="small" onClick={() => setIsHistoryOpen(true)}>
                        <History fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box>
            <HolidaysSummaryCell
                monthHolidayHours={monthHolidayHours}
                holidaysSummary={holidaysSummary}
                align="start"
                size="default"
            />
            <VacationHistoryModal open={isHistoryOpen} onClose={() => setIsHistoryOpen(false)} />
        </Box>
    );
};
